import type { RouteLocationNormalizedGeneric } from "vue-router";

export const set_default_pagination = (to: RouteLocationNormalizedGeneric) => {
  if (!to.query.page) {
    to.query.page = "1";
  }
  if (!to.query.size) {
    to.query.size = "24";
  }
};
